import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
    selector: '[flooriDragContainerHandle]',
    standalone: true,
})
export class DragContainerHandleDirective {
    static handleName = 'floori-drag-handle';

    @HostBinding('attr.floori-drag-handle')
    readonly handleCls = true;

    constructor(private readonly elRef: ElementRef) {
        this.elRef.nativeElement.style.cursor = 'move';
    }
}
